<template>
  <div>
    <el-card shadow="never">
      <div slot="header" class="clearfix">
        <span>应用管理</span>
      </div>

      <el-form :inline="true" :model="formSearch" class="demo-form-inline" size="mini">
        <el-form-item label="应用名称">
          <el-input v-model="formSearch.applyname" placeholder="应用名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getApplyPage">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="handleOpen">添加应用</el-button>
        </el-form-item>

        <div style="float:right;">
        <el-form-item>
          <span>接入必读:</span>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="clientVisible = true">①了解client申请流程</el-button>
        </el-form-item>

        <el-form-item>
          <el-button type="success" @click="handleClientDown">②下载获取长短Key工具</el-button>
        </el-form-item>
        </div>
      </el-form>

      <el-dialog title="client申请流程" :visible.sync="clientVisible">
        <h4>如不进行client申请，游戏将无法登录，请按照以下指示进行申请</h4>
        <p>
            1. 点击“下载获取长短Key工具”，下载工具getSignatureCode_200526.apk安装到任一型号安卓手机里；
        </p>
        <p>
            2. 准备出一个带正式包名的APK（可以是正式上线包，也可以是demo白包，但后缀必须是【.samsung】），安装在同一个安卓手机里；
        </p>
        <p>
            3. 打开getSignatureCode工具，输入安装APK的包名，获取short key和long key；
        </p>
        <p>
            4. 将获取的short key 和long key 以及包名，点击“client申请”进行client参数申请（我们收到申请会第一时间进行服务端里配置，参数不再下发给CP）。
        </p>
        <p>
            **温馨提示：
        </p>
        <p>
            （1）client申请不再接受以前邮件申请方式，请在此后台完成。由海外授权配置，由于时差原因一般在工作日1~3天完成。
        </p>
        <p>
            （2）client申请成功并对接群里联系运营“导入授权”方可进行账号登录，请务必尽早提前申请，避免耽误上线。
        </p>
        <p>
            （3）如果已经导入授权，但还是无法登录，请检查client申请时，包名、short key、long key是否不一致或错误，修正后再一次进行client申请。
        </p>
      </el-dialog>


      <el-table :data="tableData" @row-dblclick="handdle" size="mini">
        <el-table-column prop="applyno" label="应用编号" width="160">
        </el-table-column>
        <el-table-column prop="applyname" label="应用名称">
        </el-table-column>
        <el-table-column prop="apptype" label="应用类型">
        </el-table-column>
        <el-table-column prop="goodCount" label="商品数量">
        </el-table-column>
        <el-table-column prop="createdate" label="创建时间" :formatter="formatDate" width="180">
        </el-table-column>
        <el-table-column prop="authState" label="client授权" width="120">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.authState == '1'" type="success" disable-transitions>是</el-tag>
            <el-tag v-if="scope.row.authState == '0'" type="primary" disable-transitions>否</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="bsBizId" label="游戏备案识别码"></el-table-column>
        <el-table-column fixed="right" label="操作" width="180">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small">编辑查询</el-button>
            <el-button @click="handleClientClick(scope.row)" type="text" size="small">client申请</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        style="float:right;margin:10px"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageresult.pageSize"
        layout="total, prev, pager, next"
        :total="pageresult.totalSize">
      </el-pagination>
    </el-card>

    <el-drawer :visible.sync="drawerClient" :with-header="false" size="40%">
      <el-card shadow="never">
        <div slot="header" class="clearfix">
          <span>client申请</span>
        </div>
        <el-form :model="client" :rules="clientFormRules" ref="clientForm" label-width="110px" size="mini">
          <el-form-item label="应用名称" prop="applyname">
            <el-input v-model="client.applyname" disabled></el-input>
          </el-form-item>
          <el-form-item label="商户名称" prop="merchname">
            <el-input v-model="client.merchname" disabled></el-input>
          </el-form-item>
          <el-form-item label="包名" prop="packagename">
            <el-input v-model="client.packagename"></el-input>
            <span style="color:red">*包名须与最终上线包名一致，否则无法登录</span>
            <br/>
            <span style="color:red">*包名须以“.samsung”结尾</span>
          </el-form-item>
          <el-form-item label="short_key" prop="shortkey">
            <el-input type="textarea" :rows="3" v-model="client.shortkey"></el-input>
            <span style="color:red">*此参数与打包所用的签名相关，签名须与最终上线签名一致，否则无法登录</span>
            <br/>
            <span style="color:red">*补充说明:“如果前缀有"-"符号，请勿舍去</span>
          </el-form-item>
          <el-form-item label="long_key" prop="longkey">
            <el-input type="textarea" :rows="12" v-model="client.longkey"></el-input>
            <span style="color:red">*此参数与打包所用的签名相关，签名须与最终上线签名一致，否则无法登录</span>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onClientSubmit">确认申请</el-button>
          </el-form-item>
        </el-form>
        </el-card>
    </el-drawer>

    <el-drawer :visible.sync="drawer" :with-header="false" size="40%" :before-close="handleClose">
      <el-card shadow="never">
        <div slot="header" class="clearfix">
          <span>添加应用</span>
        </div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px" size="mini">
          <el-form-item label="应用名称" prop="applyname">
            <el-input v-model="ruleForm.applyname"></el-input>
          </el-form-item>
          <el-form-item label="应用类型" prop="apptype">
            <el-select v-model="ruleForm.apptype" placeholder="请选择应用类型">
              <el-option v-for="(item,index) in applyTypes" :key="index" :label="item.name" :value="item.code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="回调地址" prop="notifyUrl">
            <el-input v-model="ruleForm.notifyUrl" maxlength="100"></el-input>
          </el-form-item>
          <el-form-item label="游戏备案识别码(bizId)" prop="bsBizId">
            <el-input v-model="ruleForm.bsBizId" maxlength="100"></el-input>
            <div style="color:red">请注意!此处可能会影响新用户实名登录.</div>
            <div style="color:red">请确保在版署【网络游戏防沉迷实名认证系统】后台绑定本渠道，不得不写或解绑!</div>
            <div style="color:red">统一社会信用代码【9111010569634015X3】添加【北京鹏泰博兴科技有限公司】</div>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">确认添加</el-button>
          </el-form-item>
        </el-form>
        </el-card>
    </el-drawer>

    <el-drawer :visible.sync="drawer1" :with-header="false" size="80%">
      <el-card shadow="never">
        <div slot="header" class="clearfix">
          <span>{{this.apply.applyname}}</span>
          <el-button v-if="activeName == 'first'" type="primary" @click="onSaveZfb" size="small" style="width:100px;margin-left:20px;">保存</el-button>
        </div>
        <div class="drawer_body">
          <el-tabs v-model="activeName">
            <el-tab-pane label="应用信息" name="first">
              <el-form label-position="right" label-width="150px" size="mini">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="应用名称">
                      <el-input v-model="apply.applyname" :disabled="true"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="应用编号">
                      <el-input v-model="apply.applyno" :disabled="true"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="应用类型">
                      <el-input v-model="apply.apptype" :disabled="true"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="回调地址">
                      <el-input v-model="apply.notifyUrl"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>


               <el-form-item label="应用支付公钥(publicKey)">
                 <el-input type="textarea" v-model="apply.publicKey" :disabled="true"></el-input>
               </el-form-item>
               <el-form-item label="应用支付私钥(privateKey)">
                 <el-input type="textarea" v-model="apply.privateKey" rows="6" :disabled="true"></el-input>
               </el-form-item>

                <el-divider content-position="left">版署参数（请确保已经完成数据上报接入流程，详情请参阅资料包文档指南）</el-divider>
                <el-form-item label="游戏备案识别码(bizId)">
                  <el-input v-model="apply.bsBizId"></el-input>
                </el-form-item>

               <el-divider content-position="left">支付宝参数</el-divider>
               <el-form-item label="支付宝(APPID)">
                 <el-input v-model="apply.zapppid" ></el-input>
               </el-form-item>
               <el-form-item label="支付宝应用私钥(privateKey)">
                 <el-input type="textarea" v-model="apply.zprivateKey" rows="6"></el-input>
               </el-form-item>
               <el-form-item label="支付宝公钥(publicKey)">
                 <el-input type="textarea" v-model="apply.zpublicKey" rows="6"></el-input>
               </el-form-item>

               <el-divider content-position="left">腾讯微信参数</el-divider>
               <el-form-item label="腾讯微信(appId)">
                 <el-input v-model="apply.wappid"></el-input>
               </el-form-item>
               <el-form-item label="腾讯微信(mchId)">
                 <el-input v-model="apply.wmchid"></el-input>
               </el-form-item>
               <el-form-item label="腾讯微信(mchKey)">
                 <el-input v-model="apply.wmchkey"></el-input>
               </el-form-item>

               <!-- <el-form-item>
                <el-button type="primary" @click="onSaveZfb">保存</el-button>
               </el-form-item> -->
             </el-form>
            </el-tab-pane>
            <el-tab-pane label="商品信息" name="second">
              <el-form :inline="true" :model="formGoodSearch" class="demo-form-inline" size="mini">
                <el-form-item label="商品名称">
                  <el-input v-model="formGoodSearch.warename" placeholder="商品名称"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="getGoods">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="success" @click="innerDrawer = true" icon="el-icon-edit" size="mini">添加商品</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="warning" @click="handleDown">批量导入模板</el-button>
                  <span style="color:red;font-size:12px">* 如需批量导入商品可下载批量导入模板后联系对接群工作人员，以协助导入。</span>
                </el-form-item>
                <!-- <el-form-item>
                  <el-button type="success" @click="shuoming = true" icon="el-icon-edit" size="mini">注意事项</el-button>
                </el-form-item> -->
              </el-form>
             
              <p style="font-size: 12px;color: #a19393;margin: 0;">CP可选择商品编号或自定义编号对应游戏的商品计费点编号。<br>支付接口pay的sourceGood参数，
             默认取0：采用“商品编号”，如果取1：采用“自定义编号”，<br>可根据自己使用习惯自定义。（对接人员请事前和自家技术进行沟通确认）</p>
            
              <el-drawer
               :append-to-body="true"
               :with-header="false"
               :visible.sync="innerDrawer">
                 <el-card shadow="never">
                   <div slot="header" class="clearfix">
                     <span>添加商品</span>
                   </div>

                   <el-form :model="ruleAddForm" :rules="rulesAdd" ref="ruleAddForm" label-position="right" label-width="80px" size="mini">
                    <el-form-item label="商品名称" prop="warename">
                      <el-input v-model="ruleAddForm.warename"></el-input>
                    </el-form-item>
                    <el-form-item label="销售方式" prop="sale">
                      <el-select v-model="ruleAddForm.sale" placeholder="请选择销售方式" @change="handleSelectSale">
                        <el-option v-for="(item,index) in saleMethods" :key="index" :label="item.name" :value="item.code"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="销售价格" v-if="ruleAddForm.sale == '平台设置价格'" prop="fixprice">
                      <el-input v-model="ruleAddForm.fixprice" type="number">
                        <template slot="append">元/每次</template>
                      </el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" @click="submitForm('ruleAddForm')">立即添加</el-button>
                      <el-button @click="resetForm('ruleAddForm')">重置</el-button>
                    </el-form-item>
                  </el-form>
                  <div style="font-size:12px">
                    <span style="color:#E53333;">【如何选择合适的销售方式】</span><br />
                    <br />
                    销售方式1：应用传入价格<br />
                    <br />
                    方式介绍：<br />
                    商户在平台只须创建一个商品可对应游戏一个或少数商品，在商户后台无须配置太多商品信息，有相对自由灵活性。【适合对商品变化大且频繁的游戏】<br />

                    <br />
                    SDK接入要点：<br />
                    商品名称和商品价格由SDK的pay方法传入，SDK的pay方法使用统一的商品编号，并且动态传入商品金额和商品名称即可。其中，商品名称可在SDK的pay中传入，如果不传，则取平台设置的名称展示在收银台中。<br />
                    <br />
                    <br />
                    销售方式2：平台设置价格<br />
                    <br />
                    方式介绍：<br />
                    商户在平台需要创建/更新游戏所有的商品，一个商品只能对应游戏内一个计费点，商品名称和商品价格完全采用平台所设置好的内容。【适合商品少数、单一，不频繁更新商品的游戏】【如计费点多，可联系技术支持进行导入】<br />
                    <br />
                    SDK接入要点：<br />
                    SDK的pay方法传入统一的商品编号，商品名称和价格将自动获取平台所编辑好的内容，并且展示在收银台中。<br />

                    <!-- <span>【如何选择合适的销售方式】</span>
                    <p>
                        <span style="text-wrap: nowrap;">1、应用传入价格：</span>
                    </p>
                    <p>
                        <span style="text-wrap: nowrap;">方式介绍：</span>
                    </p>
                    <p>
                        <span>商户在平台只须创建一个商品可对应游戏一个或少数商品，在商户后台无须配置太多商品信息，有相对自由灵活性。【适合对商品变化大且频繁的游戏】</span>
                    </p>
                    <p>
                        <span style="text-wrap: nowrap;">SDK接入要点：</span>
                    </p>
                    <p>
                        <span>商品名称和商品价格由SDK的pay方法传入，SDK的pay方法使用统一的商品编号，并且动态传入商品金额和商品名称即可。其中，商品名称可在SDK的pay中传入，如果不传，则取平台设置的名称展示在收银台中。</span>
                    </p>
                    <p>
                        <span style="text-wrap: nowrap;">2、平台设置价格：</span>
                    </p>
                    <p>
                        <span style="text-wrap: nowrap;">方式介绍：</span>
                    </p>
                    <p>
                        <span>商户在平台需要创建/更新游戏所有的商品，一个商品只能对应游戏内一个计费点，商品名称和商品价格完全采用平台所设置好的内容。【适合商品少数、单一，不频繁更新商品的游戏】【如计费点多，可联系技术支持进行导入】</span>
                    </p>
                    <p>
                        <span style="text-wrap: nowrap;">SDK接入要点：</span>
                    </p>
                    <p>
                        <span>SDK的pay方法传入统一的商品编号，商品名称和价格将自动获取平台所编辑好的内容，并且展示在收银台中。</span>
                    </p>
                    <p>
                        <br/>
                    </p> -->
                  </div>
                 </el-card>
              </el-drawer>
              <el-divider></el-divider>
              <el-table size="mini" :data="goods" style="width: 100%">
                <el-table-column prop="id" label="商品编号" width="100" align="center"></el-table-column>
                <el-table-column prop="goodno" label="自定义编号" width="180" align="center" />
                <el-table-column prop="warename" label="商品名称" width="230" align="center"></el-table-column>
                <el-table-column prop="sale" label="销售方式" align="center"></el-table-column>
                <el-table-column prop="fixprice" label="销售价格" align="center">
                  <template slot-scope="scope">
                    <span>{{ scope.row.fixprice }}元/每次</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="100" align="center">
                  <template slot-scope="scope">
                    <el-button @click="handleUpdGoodClick(scope.row)" type="text" size="small">修改</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination style="float:right;margin:10px" @current-change="handleGoodCurrentChange"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="goodpageresult.pageSize"
                layout="total, prev, pager, next"
                :total="goodpageresult.totalSize">
              </el-pagination>
            </el-tab-pane>
            <!-- <el-tab-pane label="支付方式" name="third">
              <el-table
                size="mini"
                :data="pays"
                style="width: 100%">
                <el-table-column
                  prop="id"
                  label="编号"
                  width="80">
                </el-table-column>
                <el-table-column
                  prop="payname"
                  label="支付方式">
                </el-table-column>
                <el-table-column
                  label="操作"
                  width="180">
                  <template slot-scope="scope">
                    <el-radio-group v-model="scope.row.state">
                      <el-radio disabled label="1">启用</el-radio>
                      <el-radio disabled label="0">禁用</el-radio>
                    </el-radio-group>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane> -->
            <!-- <el-tab-pane label="优惠券设置" name="four">
              <el-radio-group v-model="apply.couponState">
                <div style="margin-top:10px;">
                  <el-radio label="true" disabled>开启：启用状态开启后收银台显示优惠券</el-radio>
                </div>
                <div style="margin-top:10px;">
                  <el-radio label="false" disabled>禁用：禁用状态开启后收银台将不显示优惠券</el-radio>
                </div>
              </el-radio-group>
            </el-tab-pane> -->
          </el-tabs>
        </div>
        </el-card>
    </el-drawer>

    <!-- 修改商品 -->
    <el-dialog title="修改商品" :visible.sync="dialogGoodInfoVisible" width="40%">
      <el-form size="mini" :model="goodInfo" :rules="rulesAdd" ref="goodInfoRuleForm" label-width="100px">
        <el-form-item label="商品名称" prop="warename">
          <el-input v-model="goodInfo.warename"></el-input>
        </el-form-item>
        <el-form-item label="自定义编号">
          <el-input v-model="goodInfo.goodno"></el-input>
        </el-form-item>
        <el-form-item label="销售方式" prop="sale">
          <el-select v-model="goodInfo.sale" placeholder="请选择销售方式" @change="handleSelectSale">
            <el-option v-for="(item,index) in saleMethods" :key="index" :label="item.name" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="销售价格" v-if="goodInfo.sale == '平台设置价格'" prop="fixprice">
          <el-input v-model="goodInfo.fixprice" type="number">
            <template slot="append">元/每次</template>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogGoodInfoVisible = false">取 消</el-button>
        <el-button type="primary" @click="updGoodInfosubmitForm">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="注意事项" :visible.sync="shuoming" width="40%">
      <div>
        <p>技术接入注意要点：</p>
        <p>1、CP可选择使用其中之一对应游戏的商品计费点编号。支付接口pay的sourceGood参数，
          如果默认取0：采用“商品编号”使用平台默认生成的；如果取1：采用“自定义商品编号”，可根据自己使用习惯自定义。</p>
        <p>2、如果选择“自定义商品编号”，自定义时字段请把控在30个字符以下。
        （以上，对接人员最好和自家技术进行沟通确认）</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="shuoming = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  data () {
    return {
      shuoming:false,
      clientVisible:false,
      dialogGoodInfoVisible:false,
      goodInfo:{},
      client: {
        applyno:'',
        applyname:'',
        merchno:'',
        merchname:'',
        packagename:'',
        shortkey:'',
        longkey:'',
      },
      apply:{
        bsBizId:''
      },
      activeName:'first',
      goods:[],
      pays:[],
      pageresult:{},
      goodpageresult:{},
      ruleForm: {
        applyno: '',
        applyname: '',
        apptype: '',
        notifyUrl:''
      },
      ruleUpdForm: {
        applyno: '',
        applyname: '',
        apptype: ''
      },
      rules: {
        applyname: [
          { required: true, message: '请输入应用名称', trigger: 'blur' }
        ],
        apptype: [
          { required: true, message: '请选择应用类型', trigger: 'change' }
        ],
        notifyUrl: [
          { required: true, message: '请输入回调地址', trigger: 'blur' }
        ],
        bsBizId: [
          { required: true, message: '请输入版署备案识别码', trigger: 'blur' },
          { pattern: /^\d{10}$/ , message: '长度为10位数字'}
        ],
      },
      clientFormRules:{
        applyname: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
        merchname: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
        packagename: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
        shortkey: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
        longkey: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
      },
      rulesAdd:{
        goodno: [
          { required: true, message: '请输入商品编号', trigger: 'blur' }
        ],
        warename: [
          { required: true, message: '请输入商品名称', trigger: 'blur' }
        ],
        sale: [
          { required: true, message: '请选择销售方式', trigger: 'change' }
        ],
        fixprice: [
          { required: true, message: '请选输入价格', trigger: 'blur' }
        ]
      },
      ruleAddForm:{
        goodno:'',
        warename:'',
        sale:'',
        fixprice:'',
        applyname:'',
        applyno:'',
        merchno:'',
        merchname:''
      },
      drawer: false,
      drawer1: false,
      drawerClient:false,
      innerDrawer:false,
      formSearch: {
        applyname: '',
        pageNum:1
      },
      tableData:[],
      applyTypes:[],//应用类型列表
      saleMethods: [],//销售方式列表
      formGoodSearch: {
        warename: '',
        applyno:'',
        pageNum:1
      },
    }
  },
  created(){
    this.getApplyPage();
    this.getApplyApply();
    this.getSaleMethod();
  },
  methods: {
    handleGoodCurrentChange(val) {
      this.formGoodSearch.pageNum=val;
      this.getGoods();
    },
    handleClose(done) {
      this.ruleForm = {
        applyno: '',
        applyname: '',
        apptype: '',
        notifyUrl:''
      };
      done();
    },
    updGoodInfosubmitForm(){
      let that = this;
      let info = this.$store.state.userInfo;
      this.goodInfo.merchno=info.userbh;
      this.goodInfo.merchname=info.username;
      this.goodInfo.applyname=this.apply.applyname;
      this.goodInfo.applyno=this.apply.applyno;
      this.$refs.goodInfoRuleForm.validate((valid) => {
        if (valid) {
          this.$ajax({
            url:"coupon-merch/goods/updGoods",
            async:false,
            methods:'POST',
            data:that.goodInfo,
            token:window.sessionStorage.getItem('token'),
            success:function(response){
              if (response.code==0) {
                that.goodInfo = {};
                that.dialogGoodInfoVisible=false;
                that.formGoodSearch.applyno = that.apply.applyno;
                that.getGoods();
              }else{
                that.$message.error(response.message);
              }
            },
            error:function(response){
              that.$message.error("请求失败");
            }
          })
        } else {
          that.$message.error('error submit!!');
          return false;
        }
      });
    },
    handleUpdGoodClick:function(row){
      this.dialogGoodInfoVisible = true;
      this.goodInfo = row;
    },
    handleCurrentChange(val) {
      this.formSearch.pageNum=val;
      this.getApplyPage();
    },
    handleOpen() {
      this.drawer=true
    },
    formatDate(row, column) {
      return moment(row.createdate).format("YYYY-MM-DD HH:mm");
    },
    handdle(row, event, column) {
      // this.ruleUpdForm = Object.assign({},row);
      // this.drawer1=true;
    },
    submitForm(ruleAddForm){
      let that = this;
      let info = this.$store.state.userInfo;
      this.ruleAddForm.merchno=info.userbh;
      this.ruleAddForm.merchname=info.username;
      // this.ruleAddForm.applyid=this.apply.id;
      this.ruleAddForm.applyname=this.apply.applyname;
      this.ruleAddForm.applyno=this.apply.applyno;
      this.$refs[ruleAddForm].validate((valid) => {
        if (valid) {
          this.$ajax({
            url:"coupon-merch/goods/addGoods",
            async:false,
            methods:'POST',
            data:that.ruleAddForm,
            token:window.sessionStorage.getItem('token'),
            success:function(response){
              if (response.code==0) {
                that.ruleAddForm = {};
                that.innerDrawer=false;
                that.formGoodSearch.applyno = that.apply.applyno;
                that.getGoods();
              }else{
                that.$message.error(response.message);
              }
            },
            error:function(response){
              that.$message.error("请求失败");
            }
          })
        } else {
          that.$message.error('error submit!!');
          return false;
        }
      });
    },
    onUpdSubmit(){
      let that = this;
      this.$refs.ruleUpdForm.validate((valid) => {
        if (valid) {
          this.$ajax({
            url:"coupon-system/menu/updMenu",
            async:false,
            methods:'POST',
            data:that.ruleUpdForm,
            token:window.sessionStorage.getItem('token'),
            success:function(response){
              if (response.code==0) {
                that.ruleUpdForm = {};
                that.drawer1=false;
                that.getApplyPage();
              }else{
                that.$message.error(response.message);
              }
            },
            error:function(){
              that.$message.error("请求失败");
            }
          })
        } else {
          alert('error submit!!');
          return false;
        }
      });
    },
    //添加
    onSubmit(){
      let that = this;
      let info = this.$store.state.userInfo;
      this.ruleForm.merchno=info.userbh;
      this.ruleForm.merchname=info.username;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$ajax({
            url:"coupon-merch/apply/addApply",
            async:false,
            methods:'POST',
            data:that.ruleForm,
            token:window.sessionStorage.getItem('token'),
            success:function(response){
              if (response.code==0) {
                that.ruleForm = {};
                that.drawer=false;
                that.getApplyPage();
              }else{
                that.$message.error(response.message);
              }
            },
            error:function(){
              that.$message.error("请求失败");
            }
          })
        } else {
          that.$message.error('error submit!!');
          return false;
        }
      });
    },
    handleClick(row){
      this.apply = row;
      this.drawer1 = true
      this.formGoodSearch.applyno = row.applyno;
      this.getGoods();
      this.getPays(row.id);
    },
    handleClientClick(row){
      this.client.applyno = row.applyno;
      this.client.applyname = row.applyname;
      this.client.merchno = row.merchno;
      this.client.merchname = row.merchname;
      this.drawerClient = true
    },
    onClientSubmit(){
      let _this = this;
      this.$refs.clientForm.validate((valid) => {
        if (valid) {
          this.$ajax({
            url:"coupon-merch/merch/add/client",
            async:false,
            methods:'POST',
            data:_this.client,
            token:window.sessionStorage.getItem('token'),
            success:function(response){
              if (response.code==0) {
                _this.client = {};
                _this.drawerClient=false;
                _this.$alert('授权申请成功，请在授权管理里查看进度', '系统提示', {
                  confirmButtonText: '确定'
                });
              }else{
                _this.$message.error(response.message);
              }
            },
            error:function(){
              _this.$message.error("请求失败");
            }
          })
        } else {
          _this.$message.error('error submit!!');
          return false;
        }
      });
    },
    getGoods(){
      let that = this;
      this.$ajax({
        url:"coupon-merch/goods/queryGoodPage",
        // async:false,
        data:that.formGoodSearch,
        token:window.sessionStorage.getItem('token'),
        success:function(response){
          if (response.code== 0) {
            // that.goods=response.data;
            that.goods=response.data.content;
            that.goodpageresult = response.data;
          }else{
            that.$message.error(response.message);
          }
        },
        error:function(){
          that.$message.error("查询失败");
        }
      })
    },
    getPays(applyid){
      let that = this;
      this.$ajax({
        url:"coupon-merch/apply/getPays",
        // async:false,
        data:{'applyid':applyid},
        token:window.sessionStorage.getItem('token'),
        success:function(response){
          if (response.code== 0) {
            that.pays=response.data;
          }else{
            that.$message.error(response.message);
          }
        },
        error:function(){
          that.$message.error("查询失败");
        }
      })
    },
    getApplyPage(){
      let that = this;
      let info = this.$store.state.userInfo;
      this.formSearch.merchno=info.userbh;
      this.$ajax({
        url:"coupon-merch/apply/getApplyPage",
        async:false,
        data:that.formSearch,
        token:window.sessionStorage.getItem('token'),
        success:function(response){
          if (response.code== 0) {
            that.tableData=response.data.content;
            that.pageresult = response.data;
          }else{
            that.$message.error(response.message);
          }
        },
        error:function(){
          that.$message.error("查询失败");
        }
      })
    },
    //获取销售方式列表
    getSaleMethod(){
      let that = this;
      this.$ajax({
        url:"coupon-system/data/getSaleMethodData",
        async:false,
        token:window.sessionStorage.getItem('token'),
        success:function(response){
          if (response.code== 0) {
            that.saleMethods=response.data;
          }else{
            that.$message.error(response.message);
          }
        },
        error:function(){
          that.$message.error("获取销售方式失败");
        }
      })
    },
    //获取应用类型列表
    getApplyApply(){
      let that = this;
      this.$ajax({
        url:"coupon-system/data/getApplyTypeData",
        async:false,
        token:window.sessionStorage.getItem('token'),
        success:function(response){
          if (response.code== 0) {
            that.applyTypes=response.data;
            console.log(response.data);
          }else{
            that.$message.error(response.message);
          }
        },
        error:function(){
          that.$message.error("获取应用类型失败");
        }
      })
    },
    handlePayClick(state,row){
      let that = this;
      this.$confirm('确认此操作吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$ajax({
            url:"coupon-merch/apply/updApplyPayState",
            async:false,
            data:{'state':state,'id':row.id},
            methods:'POST',
            token:window.sessionStorage.getItem('token'),
            success:function(response){
              if (response.code== 0) {
                that.$message(response.data);
              }else{
                that.$message.error(response.message);
              }
            },
            error:function(){
              that.$message.error("获取应用类型失败");
            }
          })
        }).catch(() => {

        });

    },
    handleSelectSale(val){
      if (val == "应用传入价格") {
        this.ruleAddForm.fixprice = 0;
      }
    },
    onSaveZfb(){

      var bsBizId = this.apply.bsBizId || '';
      bsBizId = bsBizId.replace(/\s+/g,"");
      if(bsBizId == null || bsBizId == ""){
        this.$message.error("请输入游戏备案识别码!");
        return;
      }
      let that = this;
      this.$confirm('确认此操作吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$ajax({
            url:"coupon-merch/apply/updApplyZfb",
            async:false,
            data:that.apply,
            methods:'POST',
            token:window.sessionStorage.getItem('token'),
            success:function(response){
              if (response.code== 0) {
                that.$message(response.data);
                that.getApplyPage();
              }else{
                that.$message.error(response.data);
              }
            },
            error:function(){
              that.$message.error("请求失败");
            }
          })
        }).catch(() => {

        });

    },
    handleDown(){
      window.location.href=this.$store.state.upBaseUrl + "coupon-merch/data/template2.xls"
    },
    handleClientDown(){
      window.location.href=this.$store.state.upBaseUrl + "coupon-merch/data/getSignatureCode_200526.apk"
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/merch/setapply.vue